import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PASS_THROUGH } from '@attain-apps/transformers'
import gql from 'graphql-tag'

import type * as assistant from '../../../../../../assistant'

const DOC = gql`
  mutation GuideArchive($tenantId: ID!, $zoneId: ID!, $archive: Archive!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        guideArchive(archive: $archive)
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default<
  graphql.schema.GuideArchiveMutation,
  assistant.oneOff.models.Ask.Response | undefined,
  assistant.oneOff.models.Ask.Response
>(
  graphql.transformers.OUT.select(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'guideArchive',
        graphql.transformers.OUT.nest(
          'replies',
          graphql.transformers.OUT.default(
            graphql.transformers.OUT.tuple<
              string,
              readonly assistant.oneOff.models.Message.Content[]
            >([PASS_THROUGH]),
            [],
          ),
        ),
      ),
    ),
  ),
  {},
)

export const execute = graphql.createExecutor<
  graphql.schema.GuideArchiveMutation,
  assistant.oneOff.models.Ask.Response,
  graphql.schema.GuideArchiveMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
